/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';

type AttributeCardArgs = {
  attribute: string;
  canSelect: boolean;
  isDisabled: boolean;
  isSelected: boolean;
  onSelect: () => unknown;
  onDeselect: () => unknown;
};

export default class AttributeCard extends Component<AttributeCardArgs> {}
